import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getPurchaseDetail } from '_redux/modules/order'
import { BUYER_UNPAID, HOST_ORDER_UNPAID, HOST_ORDER_SUBMITTED_UNPAID } from '_utils/constant'

const useHitpayPolling = (buyerStatus, status, orderRef) => {
  const [isHitpayPolling, setIsHitpayPolling] = useState(false)
  const dispatch = useDispatch()

  const getHitpayRedirectStatus = () => {
    let _status = null
    const loc = window.location
    if (loc.search) {
      _status = new URLSearchParams(loc.search).get('status')
    }
    if (!_status && loc.hash) {
      _status = new URLSearchParams(loc.hash.replace(/^#&?/, '')).get('status')
    }
    return _status
  }

  useEffect(() => {
    const hitpayStatus = getHitpayRedirectStatus()
    const isUnpaid =
      buyerStatus === BUYER_UNPAID &&
      (status === HOST_ORDER_UNPAID || status === HOST_ORDER_SUBMITTED_UNPAID)

    if (hitpayStatus === 'completed' && isUnpaid) {
      setIsHitpayPolling(true)
      let pollCount = 0
      const maxPolls = 10

      const intervalId = setInterval(() => {
        pollCount += 1
        if (pollCount >= maxPolls) {
          clearInterval(intervalId)
          setIsHitpayPolling(false)
          return
        }
        dispatch(getPurchaseDetail(orderRef))
      }, 2000)

      return () => {
        clearInterval(intervalId)
        setIsHitpayPolling(false)
      }
    }

    setIsHitpayPolling(false)
  }, [buyerStatus, status, orderRef, dispatch])

  return isHitpayPolling
}

export default useHitpayPolling
